import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import styles from './styles.module.scss';
export var ToggleSwitch = function (_a) {
    var options = _a.options, defaultValue = _a.defaultValue, onChange = _a.onChange, _b = _a.id, id = _b === void 0 ? 'toggle-switch' : _b, _c = _a.ariaLabel, ariaLabel = _c === void 0 ? 'Toggle options' : _c;
    var _d = useState(defaultValue || options[0].value), selectedValue = _d[0], setSelectedValue = _d[1];
    var handleToggle = function (value) {
        setSelectedValue(value);
        onChange === null || onChange === void 0 ? void 0 : onChange(value);
    };
    var handleKeyDown = function (e, value) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleToggle(value);
        }
    };
    var getSliderPosition = function () {
        var index = options.findIndex(function (option) { return option.value === selectedValue; });
        return "translateX(".concat(index * (100 - 14), "%)");
    };
    return (_jsxs("div", { className: styles.toggleSwitch, role: "group", "aria-label": ariaLabel, children: [_jsx("div", { className: styles.slidingBackground, style: { transform: getSliderPosition() }, "aria-hidden": "true" }), options.map(function (option, index) { return (_jsx("button", { type: "button", id: "".concat(id, "-").concat(option.value), className: "".concat(styles.toggleOption, " ").concat(selectedValue === option.value ? styles.active : ''), onClick: function () { return handleToggle(option.value); }, onKeyDown: function (e) { return handleKeyDown(e, option.value); }, "aria-pressed": selectedValue === option.value, "aria-label": "Select ".concat(typeof option.label === 'string' ? option.label : option.value), style: { margin: index === 0 ? '0 0 0 4px' : '0 4px 0 0' }, children: option.label }, option.value)); })] }));
};
